import { render } from "./Survey2024SmilePro.vue?vue&type=template&id=2f0b6a7f"
import script from "./Survey2024SmilePro.vue?vue&type=script&lang=js"
export * from "./Survey2024SmilePro.vue?vue&type=script&lang=js"

import "./Survey2024SmilePro.vue?vue&type=style&index=0&id=2f0b6a7f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__